/**
 * NO JS
 *
 * By default, in <html> markup we add "no-js" class that will be removed when JS is running.
 */

document.documentElement.classList.remove('no-js')
